import { styled } from '@grupoboticario/flora-react-system'

export const StyledTypography = styled('p', {
  variants: {
    /**
     * Obrigatório, especifica em qual formato de dispositivo o componente está aplicado.
     */
    viewport: {
      desktop: {},
      mobile: {},
    },

    /**
     * Obrigatório, define o tamanho do texto.
     */
    fontSize: {
      display: {},
      heading: {},
      title: {},
      subtitle: {},
      bodyLargeStandard: {
        fontSize: '$bodyLarge',
        lineHeight: '$bodyLargeStandard',
      },
      bodyLargeShort: {
        fontSize: '$bodyLarge',
        lineHeight: '$bodyLargeShort',
      },
      bodySmallStandard: {
        fontSize: '$bodySmall',
        lineHeight: '$bodySmallStandard',
      },
      bodySmallShort: {
        fontSize: '$bodySmall',
        lineHeight: '$bodySmallShort',
      },
      exceptionsAuxiliar: {
        fontSize: '$exceptionsAuxiliar',
        lineHeight: '$exceptionsAuxiliar',
      },
      exceptionsRestricted: {
        fontSize: '$exceptionsRestricted',
        lineHeight: '$exceptionsRestricted',
      },
    },

    /**
     * Opcional, define o peso do texto. Caso não seja informado, o valor será "regular".
     */
    fontWeight: {
      regular: {
        fontWeight: '$fontWeights$regular',
      },
      medium: {
        fontWeight: '$fontWeights$medium',
      },
      bold: {
        fontWeight: '$fontWeights$bold',
      },
    },

    /**
     * Opcional, define a cor do texto. Caso não seja informado, o valor será "none".
     * Seguindo as definições de design, esta propriedade não existe dentro das fontSize de display, heading, title e subtitle. Para mais informações, acesse: [figma](https://www.figma.com/design/c3hqLfoegWKsYRJB3BfdEc/branch/0Udzju4338MtCW1NYtj8sG/%E2%9C%AA-%5BV2%5D-Core-Components-%E2%9C%AA?m=auto&node-id=37446-137&t=7kGdpkRMWhjB46eK-1)
     */
    textDecoration: {
      none: {
        textDecoration: 'none',
      },
      underline: {},
      'line-through': {},
    },

    /**
     * Opcional, torna o texto invisível em tela, mas garante a acessibilidade em leitores de tela. Caso não seja informado, o valor será false.
     */
    screenReaderOnly: {
      true: {
        position: 'absolute',
        clip: 'rect(1px, 1px, 1px, 1px)',
        '-webkit-clip-path': 'inset(0px 0px 99.9% 99.9%)',
        'clip-path': 'inset(0px 0px 99.9% 99.9%)',
        overflow: 'hidden',
        height: '1px',
        width: '1px',
        padding: 0,
        border: 0,
      },
      false: {},
    },
  },

  compoundVariants: [
    {
      viewport: 'desktop',
      fontSize: 'display',
      css: {
        fontSize: '$displayDesk',
        lineHeight: '$displayDesk',
      },
    },
    {
      viewport: 'desktop',
      fontSize: 'heading',
      css: {
        fontSize: '$headingDesk',
        lineHeight: '$headingDesk',
      },
    },
    {
      viewport: 'desktop',
      fontSize: 'title',
      css: {
        fontSize: '$titleDesk',
        lineHeight: '$titleDesk',
      },
    },
    {
      viewport: 'desktop',
      fontSize: 'subtitle',
      css: {
        fontSize: '$subtitleDesk',
        lineHeight: '$subtitleDesk',
      },
    },
    {
      viewport: 'mobile',
      fontSize: 'display',
      css: {
        fontSize: '$displayMobile',
        lineHeight: '$displayMobile',
      },
    },
    {
      viewport: 'mobile',
      fontSize: 'heading',
      css: {
        fontSize: '$headingMobile',
        lineHeight: '$headingMobile',
      },
    },
    {
      viewport: 'mobile',
      fontSize: 'title',
      css: {
        fontSize: '$titleMobile',
        lineHeight: '$titleMobile',
      },
    },
    {
      viewport: 'mobile',
      fontSize: 'subtitle',
      css: {
        fontSize: '$subtitleMobile',
        lineHeight: '$subtitleMobile',
      },
    },

    // Definições de textDecoration line-through
    {
      fontSize: 'bodyLargeStandard',
      textDecoration: 'line-through',
      css: {
        textDecoration: '$textDecorations$strikeThrough',
      },
    },
    {
      fontSize: 'bodyLargeShort',
      textDecoration: 'line-through',
      css: {
        textDecoration: '$textDecorations$strikeThrough',
      },
    },
    {
      fontSize: 'bodySmallStandard',
      textDecoration: 'line-through',
      css: {
        textDecoration: '$textDecorations$strikeThrough',
      },
    },
    {
      fontSize: 'bodySmallShort',
      textDecoration: 'line-through',
      css: {
        textDecoration: '$textDecorations$strikeThrough',
      },
    },
    {
      fontSize: 'exceptionsAuxiliar',
      textDecoration: 'line-through',
      css: {
        textDecoration: '$textDecorations$strikeThrough',
      },
    },
    {
      fontSize: 'exceptionsRestricted',
      textDecoration: 'line-through',
      css: {
        textDecoration: '$textDecorations$strikeThrough',
      },
    },

    // Definições de textDecoration underline
    {
      fontSize: 'bodyLargeStandard',
      textDecoration: 'underline',
      css: {
        textDecoration: '$textDecorations$underline',
      },
    },
    {
      fontSize: 'bodyLargeShort',
      textDecoration: 'underline',
      css: {
        textDecoration: '$textDecorations$underline',
      },
    },
    {
      fontSize: 'bodySmallStandard',
      textDecoration: 'underline',
      css: {
        textDecoration: '$textDecorations$underline',
      },
    },
    {
      fontSize: 'bodySmallShort',
      textDecoration: 'underline',
      css: {
        textDecoration: '$textDecorations$underline',
      },
    },
    {
      fontSize: 'exceptionsAuxiliar',
      textDecoration: 'underline',
      css: {
        textDecoration: '$textDecorations$underline',
      },
    },
    {
      fontSize: 'exceptionsRestricted',
      textDecoration: 'underline',
      css: {
        textDecoration: '$textDecorations$underline',
      },
    },
  ],

  defaultVariants: {
    viewport: 'desktop',
    fontSize: 'display',
    fontWeight: 'regular',
    textDecoration: 'none',
  },
})
